<template>
  <masked-input
    ref="cpf"
    v-model="value_"
    :mask="constroiMascara"
    class="form-control"
    :disabled="disabled"
    @change="enviarParaPai"
  />
</template>

<script>
export default {
  name: 'InscricaoFederal',
  props: {
    value: {
      type: String,
      default: null,
    },
    tipoInscricao: {
      type: String,
      default: 'cpf',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valueInner: null,
    }
  },
  computed: {
    value_: {
      get() {
        return this.valueInner ? this.valueInner : this.value
      },
      set(newValue) {
        this.valueInner = newValue
        return this.valueInner
      },
    },
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.valueInner = newValue
      }
    },
  },
  created() {
    this.valueInner = this.value
  },
  methods: {
    constroiMascara() {
      if (this.tipoInscricao === 'cpf') {
        return this.constroiMascaraCpf()
      }
      return this.mascaraCadFederal()
    },
    constroiMascaraCpf() {
      return [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    },
    mascaraCadFederal() {
      return [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    },
    enviarParaPai() {
      // eslint-disable-next-line no-underscore-dangle
      this.$emit('change', this.value_)
      // eslint-disable-next-line no-underscore-dangle
      this.$emit('input', this.value_)
    },
  },
}
</script>
